module.exports = __webpack_public_path__ + "static/media/back.6172a1a4.svg";